import axios from "axios";
import {constants} from "@/constants/constants";
import { formatDataService } from '@/_helpers/format-data';
import { getUserSelectType } from '@/_helpers/order';

export const orderService = {
    getSingleOrder,
    getOrders,
    createNewOrder,
    closeOrder,
    signAndCloseOrder,
    closePackagePlanOrder,
    cancelOrder,
    cancelPackagePlanOrder,
    updateOrder,
    getOccupiedTables,
    printInvoiceOrder,
    downloadInvoiceOrder,
    getUsers,
    getPosUsers,
    getCheckPrint,
    deleteItem,
    reopenOrder,
    resetOrder,
    adjustOrder,
    recalculateOrder,
    getOrderAvailablePackagePlans,
    // deleteOrder
}

function getCheckPrint(data) {
    return axios.post(`/orders/${data.id}/print`, {}, {
        responseType: 'arraybuffer'
    })
    .then((res) => {
        return res.data
    }).catch((err) => {
        return Promise.reject(err)
    })
}

function getOrders(data) {
    return axios.get(
        `/orders`, {
            params: data
        }).then((res) => {
        return res.data
    }).catch((err) => {
        return Promise.reject(err)
    })
}

function getSingleOrder(id) {
    return axios.get(`/orders/${id}`).then((res) => {
        return res.data
    }).catch((err) => {
        return Promise.reject(err)
    })
}

function getSingleOrderLogs(id) {
    return axios.get(`/orders/${id}`).then((res) => {
        return res.data
    }).catch((err) => {
        return Promise.reject(err)
    })
}

function getOccupiedTables(data) {
    return axios.get(
        `/orders/occupied-tables`, {
            params: data
        }).then((res) => {
        return res.data
    }).catch((err) => {
        return Promise.reject(err)
    })
}

function createNewOrder(id, items, selected_order, is_split) {
    let data = {
        table: selected_order.table,
        payers: [],
        payment_type: selected_order.payment_type,
        seat: selected_order.seat ? selected_order.seat : 1,
        items: items,
        splited_order_id: is_split,
        with_discount: selected_order.with_discount ? selected_order.with_discount : false
    }
    if (selected_order.payers.length) {
        selected_order.payers.forEach((o) => {
            const additionModeId = o.addition_mode?.id || constants.payerAddedModes[0].id;
            const payer = {
                user_profile_id: o.id,
                addition_mode_id: additionModeId,
                select_type: getUserSelectType(additionModeId),
            }

            if (payer.select_type === 'barcode' && !!o.barcode_scan_type) {
                payer['barcode_scan_type'] = o.barcode_scan_type;
            }

            data.payers.push(payer);
        })
        /*data.payers.push({
            user_profile_id: selected_order.payers[0].id,
            addition_mode_id: o.addition_mode?.id || 1,
        });*/
    }
    if (selected_order.opened_by) {
        data.opened_by = selected_order.opened_by.id
        // data.created_at = selected_order.opened_by.id
    }
    return axios.post(
        `/orders`, data).then(res => {
            return res
        }).catch((err) => {
            return Promise.reject(err)
        })
}

// function deleteOrder(data) {
//     return axios.delete(
//         `orders/${data.id}`
//         ).then(res => {
//         return res
//     }).catch((err) => {
//         return Promise.reject(err)
//     })
// }

function cancelOrder(data) {
    return axios.post(
        `orders/${data.id}/cancel`,
        {
            reason: data.text
        }).then(res => {
        return res
    }).catch((err) => {
        return Promise.reject(err)
    })
}

function cancelPackagePlanOrder(data) {
    return axios.post(
        `orders-package-plan/${data.id}/cancel`,
        {
            reason: data.text
        }).then(res => {
        return res
    }).catch((err) => {
        return Promise.reject(err)
    })
}

function closePackagePlanOrder(data) {
    return axios.post(`orders-package-plan/${data.id}/close`).then(res => {
        return res;
    }).catch((err) => {
        return Promise.reject(err);
    })
}

function closeOrder(data) {
    const orderData = {
        payment_type: data.payment_type,
    }
    if (data.payment_type === 2) {
        orderData['sys_acc_number'] = data.houseAccount;
        orderData['payers'] = data.payers;
    }

    return axios.post(`orders/${data.id}/close`, orderData).then(res => {
        return res;
    }).catch((err) => {
        return Promise.reject(err);
    })
}

function signAndCloseOrder(data) {
    const payload = {
        user_profile_id: data.user_profile_id,
        signature_data: data.signature_data,
        gratuity_type: data.gratuity_type,
    };

    if (data.gratuity_type === constants.gratuityTypes.percentage) {
        payload.gratuity_percent = data.gratuity_percent;
    } else {
        payload.gratuity_amount = data.gratuity_amount;
    }

    return axios.post(
        `orders/${data.id}/guest-signature-flow/sign-and-close`,
        payload
    );
}


// function closeOrder(data) {
//     const orderData = {
//         payment_type: data.payment_type,
//     }
//     if (data.payment_type === 2) {
//         orderData['sys_acc_number'] = data.houseAccount;
//     } else {
//         orderData['payers'] = [];
//         if (data.payers && data.payers.length) {
//             data.payers.forEach((o) => {
//                 orderData['payers'].push({
//                     user_profile_id: o.id,
//                     addition_mode_id: o.addition_mode?.id || constants.payerAddedModes[0].id,
//                 })
//             })
//         }
//     };
//     return axios.post(`orders/${data.id}/close`, orderData).then(res => {
//         return res;
//     }).catch((err) => {
//         return Promise.reject(err);
//     })
// }

function updateOrder(items, selected_order, change_table, change_gratuity) {
    let data = {
        payers: [],
        items: items,
        seat: selected_order.seat ? selected_order.seat : 1,
        package_plan_user_profile_id: selected_order.package_plan_user_profile_id ?? null,
        items_discount_value: selected_order.items_discount_value >= 0 ? selected_order.items_discount_value : null,
        items_discount_type: selected_order.items_discount_type ? selected_order.items_discount_type : null,
    }

    data = formatDataService.addDiscountToPayload(data, selected_order);

    if (selected_order.payers.length) {
        selected_order.payers.forEach((o) => {
            const additionModeId = o.addition_mode?.id || constants.payerAddedModes[0].id;

            const payer = {
                user_profile_id: o.id,
                addition_mode_id: additionModeId,
                select_type: getUserSelectType(additionModeId),
            }

            if (payer.select_type === 'barcode' && !!o.barcode_scan_type) {
                payer['barcode_scan_type'] = o.barcode_scan_type;
            }

            data.payers.push(payer);
        })
    }
    if (selected_order.payment_type) {
        data['payment_type'] = selected_order.payment_type;
    }
    if (change_table) {
        data['table'] = selected_order.table;
    }
    if (selected_order.seat) {
        data['seat'] = selected_order.seat;
    }
    if (selected_order.serviced_by !== null) {
        data['crew_id'] = selected_order.serviced_by.id
    }

    if (change_gratuity) {
        data['gratuity_type'] = change_gratuity.gratuity_type === 'amount'
            ? constants.gratuityTypes.amount
            : constants.gratuityTypes.percentage;

        if (change_gratuity.gratuity_type === 'amount') {
            data['gratuity_amount'] = change_gratuity.gratuity_amount;
        } else if (change_gratuity.gratuity_type === 'percentage') {
            data['gratuity_percent'] = change_gratuity.gratuity_percent;
        }
    }

    return axios.put(`/orders/${selected_order.id}`, data).then(res => {
        return res
    }).catch((err) => {
        return Promise.reject(err);
    })
}

function reopenOrder(data) {
    return axios.post(
        `orders/${data.id}/reopen`,
        {
            reason: data.reason
        }).then(res => {
        return res
    }).catch((err) => {
        return Promise.reject(err)
    })
}

function resetOrder(data) {
    const orderData = {
        reason: '',
        payment_type: data.payment_type,
    };
    if (data.payment_type === 1) {
        orderData['payers'] = [];

        data.payers.forEach((el) => {
            const payer = {
                user_profile_id: el.profile_id,
                addition_mode_id: el.addition_mode.id,
                select_type: getUserSelectType(el.addition_mode.id),
            }

            if (payer.select_type === 'barcode' && !!el.barcode_scan_type) {
                payer['barcode_scan_type'] = el.barcode_scan_type;
            }

            orderData['payers'].push(payer);
        });
    };
    if (data.payment_type === 2) {
        orderData['sys_acc_number'] = data.houseAccount;
    };
    return axios.post(
        `orders/${data.id}/reset`, orderData).then(res => {
        return res;
    }).catch((err) => {
        return Promise.reject(err);
    })
}


const getAdjustData = (order, reason) => {
    let orderData = {
        reason,
        payment_type: order.payment_type,
    };

    orderData = formatDataService.addDiscountToPayload(orderData, order);
    orderData = formatDataService.addGratuityToPayload(orderData, order);

    if (order?.items?.length > 0) {
        orderData['items'] = [];

        order?.items.forEach((item) => {
            let itemData = {
                id: item.id,
            }

            itemData = formatDataService.addDiscountToPayload(itemData, item);
            orderData.items.push(itemData);
        });
    }

    switch (order.payment_type) {
        case 1:
            orderData['payers'] = order.payers.map((payer) => {
                const payerEl = {
                    user_profile_id: payer.id,
                    addition_mode_id: payer.addition_mode.id,
                    select_type: getUserSelectType(payer.addition_mode.id),
                }

                if (payerEl.select_type === 'barcode') {
                    payerEl['barcode_scan_type'] = payer.barcode_scan_type;
                }

                return payerEl
            });

            break;
        case 2:
            orderData['sys_acc_number'] = order.houseAccount;
            break;
    }

    return orderData;
}

async function getOrderAvailablePackagePlans(orderId) {
    try {
        return await axios.get(`orders/${orderId}/package-plans`);
    } catch (error) {
        console.error(error);
    }
}

async function adjustOrder(order, reason) {
   const orderData = getAdjustData(order, reason);

    try {
        return await axios.post(`orders/${order.id}/adjust`, orderData);
    } catch (error) {
        console.error(error);
    }
}

async function recalculateOrder(order, reason = '') {
    const orderData = getAdjustData(order, reason);

    try {
        return await axios.put(`orders/${order.id}/recalculate`, orderData);
    } catch (error) {
        console.error(error);
    }
}

function printInvoiceOrder(id) {
    return axios.post(
        `orders/${id}/print`,
    ).then(res => {
        return res
    }).catch((err) => {
        return Promise.reject(err)
    })
}

function downloadInvoiceOrder(id) {
    return axios.post(
        `orders/${id}/download`,
    ).then(res => {
        return res
    }).catch((err) => {
        return Promise.reject(err)
    })
}

function getUsers(data) {
    return axios.get(`/user-profiles`, {
        params: data
    })
    .then((res) => {
        return res.data
    }).catch((err) => {
        return Promise.reject(err)
    })
}

function getPosUsers(data) {
    return axios.get(`/users`, {
        params: data
    })
    .then((res) => {
        return res.data
    }).catch((err) => {
        return Promise.reject(err)
    })
}

function deleteItem(data, id, orderId) {
    return axios.patch(`/orders/${orderId}/items/${id}/cancel`, data)
    .then((res) => {
        return res.data
    }).catch((err) => {
        return Promise.reject(err)
    })
}
